import { Link } from "react-router-dom";
import { Leaf, ArrowLeft } from "lucide-react";

export default function PublicPageHeader() {
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/90 backdrop-blur-sm">
      <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-4 sm:px-6">
        <Link to="/" data-testid="public-header-logo" className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-teal-700 text-white">
            <Leaf className="h-5 w-5" />
          </div>
          <span className="text-lg font-semibold text-slate-900">RootLyst</span>
        </Link>
        <Link to="/" data-testid="public-header-back-home" className="flex items-center gap-1.5 text-sm font-medium text-slate-600 transition-colors hover:text-teal-700">
          <ArrowLeft className="h-4 w-4" /> Back to Home
        </Link>
      </div>
    </header>
  );
}
